import { MarketplaceCronSettingListPage } from "@/features/marketplace-cron/pages/MarketplaceCronSettingListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/marketplace-automation/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["marketplace_campaigns.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: MarketplaceCronSettingListPage,
});
